import { Box, Typography } from "@mui/material";

export default function VariantSnapshotLabel({
  productName,
  variantLabel = null,
  secondary = null,
}) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography fontWeight={850}>{productName}</Typography>
      {variantLabel && (
        <Typography variant="body2" color="primary.main" fontWeight={750}>
          {variantLabel}
        </Typography>
      )}
      {secondary && (
        <Typography variant="caption" color="text.secondary">
          {secondary}
        </Typography>
      )}
    </Box>
  );
}
